import React, { useEffect, useState, forwardRef, useRef } from "react";
import { useHistory } from "react-router-dom";

import clsx from "clsx";
import {
  Button,
  Form,
  OverlayTrigger,
  Popover,
  Tooltip,
} from "react-bootstrap";
import Switch from "react-switch";
import {
  CToast,
  CToastBody,
  CToastClose,
  CToastHeader,
} from "@coreui/bootstrap-react";

import iconLeftArrow from "../../../assets/images/icon-left-arrow.png";
import iconChat from "../../../assets/images/chat-icon.png";
import Chat from "../../../assets/images/chat.png";
import iconArrowDown from "../../../assets/images/arrow-down.png";

import Canal from "../../../assets/images/canal.png";
import CanalSelected from "../../../assets/images/canal-selected.png";
import Norme from "../../../assets/images/norme.png";
import NormeSelected from "../../../assets/images/norme-selected.png";
import Motif from "../../../assets/images/motif.png";
import MotifSelected from "../../../assets/images/motif-selected.png";
import Autre from "../../../assets/images/autre.png";
import AutreSelected from "../../../assets/images/autre-selected.png";
import Plus from "../../../assets/images/plus-cercle.png";
import PointsDragDrop from "../../../assets/images/points-drag-drop.png";
import ArrowDown from "../../../assets/images/arrow-down-.png";
import ArrowUpSelected from "../../../assets/images/arrow-up-selected.png";
import PenSelected from "../../../assets/images/selected-pen.png";
import CheckCerclePrimary from "../../../assets/images/check-circle-primary.png";
import Trash from "../../../assets/images/trash.png";
import Close from "../../../assets/images/close.png";

import Rectangle from "../../../assets/images/Rectangle.png";
import CheckSucessAlert from "../../../assets/images/check-success-alert.png";
import { useDispatch, useSelector } from "react-redux";
import "../AddGrille/addGrille.css";
import { ArrowUp } from "react-feather";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Critere from "./critere";
import { updateGrille,createGrille, getAllGrilles } from "../../../redux/actions/grille";
import { useLocation } from "react-router-dom";

const EditGrille = () => {
  const history = useHistory();
  const [clickedAttributes, setClickedAttributes] = useState(false);
  const [checked, setChecked] = useState(false);
  const [selectedGrille, setSelectedGrille] = useState("");
  const [isCanal, setIsCanal] = useState(false);
  const [isNorme, setIsNorme] = useState(false);
  const [isMotif, setIsMotif] = useState(false);
  const [isAutre, setIsAutre] = useState(false);
  const [openGroupeCritere, setOpenGroupeCritere] = useState(false);
  const [groupeCritereNameEdit, setGroupeCritereNameEdit] = useState(false);
  const [isOpenComment, setIsOpenComment] = useState(false);
  const [isOpenComment1, setIsOpenComment1] = useState(false);

  const [editNameCritere, setEditNameCritere] = useState(false);
  const [editNameCritere1, setEditNameCritere1] = useState(false);

  const [groupeCritereName, setGroupeCritereName] = useState("");
  const [formerrors, setFormErrors] = useState([]);
  const [grilles, setGrilles] = useState([]);
  const [critere, setCritere] = useState([]);
  const [criteres, setCriteres] = useState([]);
  const [count, setCount] = useState(0);
  const [countg, setCountg] = useState(0);
  const [countgc, setCountgc] = useState(0);
  const [countc, setCountc] = useState(0);

  const [array, setArray] = useState([]);
  const [array1, setArray1] = useState([]);
  const [array2, setArray2] = useState({});
  const [array3, setArray3] = useState({});
  const [array4, setArray4] = useState({});

  const [selecetbonus, setSelecetbonus] = useState({});

  // useEffect(()=>{

  // },[])
  const { datagrilles, datagrille } = useSelector((state) => state.grille);
  const { user } = useSelector((state) => state.auth);

  const { message } = useSelector((state) => state.message);
  const [selectedcritere, setSelectedcritere] = useState({});
  const [selectedgroupecritere, setSelectedgroupecritere] = useState({});

  const [selectedgrille, setSelectedgrille] = useState({});
  const [selectededitgc, setSelectededitgc] = useState({});
  const [dataov, setDataov] = useState({});

  const [currentIDUser, setCurrentIDUser] = useState(0);

  const ref = useRef(null);
  const [valeur, setValeur] = useState({
    name: "",
    color: "none",
    CriteriaOption: [
      {
        name: "",
        icon: "ICO.PNG",
        color: "none",
        CriteriaOptionValue: [
          {
            name: "",
            score: 0,
          },
        ],
      },
    ],
  });

  const location = useLocation();
  //set data to send par default
  const dup = location?.state?.dup;
  console.log(location);
  const [value, setValue] = useState(
    dup
      ? datagrille
      : { name: "", description: "", userId: 1, CriteriaGroup: [] }
  );
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  console.log(datagrille);
  useEffect(() => {
    var currentUser = JSON.parse(localStorage.getItem("user_auth0"));
    setCurrentIDUser(1);

    setValue({
      ...value,
      userId: JSON.parse(localStorage.getItem("user"))?.id,
    });

    //if (dup) {
      // console.log(datagrille)

      setValue(datagrille);
      console.log("value",value)
      setOpenGroupeCritere(true);
      selectedgrille[0] = true;
      selectedgrille[1] = true;
      setSelectedgrille({ ...selectedgrille });
    //}
  }, [datagrille]);
  // ****************
  const handeladdGroupeCriteres = () => {
    const itemss = Array.from(grilles);
    const staticGrilles = {
      name: "Groupe de critere |",
      description: "",
      Criteria: [],
    };

    itemss.push(staticGrilles);

    setGrilles(itemss);
    if (dup) {
      value?.CriteriaGroup.push(staticGrilles);
    } else {
      value.CriteriaGroup = itemss;
    }

    setCountg(countg + 1);
    selectedgrille[countg] = false;
    setSelectedgrille({ ...selectedgrille });
  };
  const handelClosecommentCritere = (boll) => {
    setIsOpenComment1(boll);
  };
  //ajouter Critere
  const handeladdCriters = (id) => {
    const itemss = Array.from(critere);
    const statcitgrille = {
      name: "",
      description: "",
      CriteriaValue: [],
      CriteriaOption: [],
    };

    itemss.push(statcitgrille);
    setCritere(itemss);

    if (dup) {
      value?.CriteriaGroup[id]?.Criteria.push(statcitgrille);
    } else {
      value?.CriteriaGroup[id]?.Criteria.push(statcitgrille);
    }

    setCount(count + 1);
  };
  //supprimer groupe critere
  const handelDeleteGroupeGrilles = (id) => {
    const item = value.CriteriaGroup.slice(0, id);
    const item2 = value.CriteriaGroup.slice(id + 1);
    var items3 = item.concat(item2);
    setGrilles(items3);
    setValue({
      ...value,
      CriteriaGroup: items3,
    });
  };
  //supprimer  critere
  const handelDeleteCriters = (id, id1) => {
    const item = value.CriteriaGroup[id1].Criteria.slice(0, id);
    const item2 = value.CriteriaGroup[id1].Criteria.slice(id + 1);
    var items3 = item.concat(item2);

    setCriteres(items3);
    value.CriteriaGroup[id1].Criteria = items3;

    setValue({
      ...value,
      CriteriaGroup: [...value.CriteriaGroup],
    });
  };
  function handleOnDragEnd(result) {}
  function handleOnDragEndCritere(result) {}
  const handelchangeNomNouvelleGrille = (e) => {
    setValue({ ...value, name: e.target.value });
    if (value?.name?.length > 0) {
      setFormErrors(formerrors.filter((e) => e !== "name"));
    }
  };
  const handelchangeAttributNouvelleGrille = (e) => {
    const index = array.indexOf(e);

    if (index > -1) {
      let item = Array.from(array);
      item.splice(index, 1);
      setArray(item);
      setValue({ ...value, attributes: item });
    } else {
      let item = Array.from(array);
      item.push(e);

      setArray(item);
      setValue({ ...value, attributes: item });
    }
  };

  const handelchangeDescriptionNouvelleGrille = (e) => {
    setValue({ ...value, description: e.target.value });

    if (e.key === "Enter") {
      setIsOpenComment(!isOpenComment);
    }
  };
  const handelchangeDescriptionNouvelleCritere = (e) => {
    value.CriteriaGroup[countg - 1].description = e.target.value;
    setValue({
      ...value,
      CriteriaGroup: [...value.CriteriaGroup],
    });

    if (value.description.length > 0) {
      setFormErrors(formerrors.filter((e) => e !== "description"));
    }
    if (e.key === "Enter") {
      setIsOpenComment(!isOpenComment);
    }
  };
  const handelchangeDescriptionCritere = (e, idgc, idc) => {
    value.CriteriaGroup[idgc].Criteria[idc].description = e.target.value;
    setValue({
      ...value,
      CriteriaGroup: [...value.CriteriaGroup],
    });

    if (e.key === "Enter") {
      handelClosecommentCritere(false);
    }
  };
  const handelChangeNamecritere = (e, datag, datac) => {
    value.CriteriaGroup[datac].Criteria[datag].name = e.target.value;
    // console.log("datac",value.CriteriaGroup[datac]);

    if (value?.CriteriaGroup[datag]?.Criteria[datac]?.name.length > 0) {
      setFormErrors(formerrors.filter((e) => e !== "namecritria"));
    }
    if (e.key === "Enter") {
      selectedcritere[datag] = false;
      selectedgroupecritere[datac] = false;
      setSelectedcritere({ ...selectedcritere });
      setSelectedgroupecritere({ ...selectedgroupecritere });
    }
  };
  const handelchangeGroupCriterename = (e, id) => {
    value.CriteriaGroup[id].name = e.target.value;
    if (value.CriteriaGroup[id].name.length > 0) {
      setFormErrors(formerrors.filter((e) => e !== "namegroupecritria"));
    }
    if (e.key === "Enter") {
      selectededitgc[id] = false;
      setSelectededitgc({ ...selectededitgc });
    }
  };
  const hasError = (key) => {
    return formerrors.indexOf(key) !== -1;
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    //VALIDATE
    var errors = [];
    //firstname
    if (value.name === "") {
      errors.push("name");
    }

    if (
      value.CriteriaGroup.map((e) => e.name)[0] === "Critere |" &&
      value.name !== ""
    ) {
      errors.push("namegroupecritria");
    }
    if (value.CriteriaGroup.map((e) => e.Criteria).length !== 0) {
      if (
        value.CriteriaGroup.map((e) => e.Criteria.map((e) => e.name))[0][0] ===
          "" &&
        value.CriteriaGroup.map((e) => e.name)[0] !== "Critere |"
      ) {
        errors.push("namecritria");
      }
    }

    setFormErrors(errors);

    if (errors.length > 0) {
      return false;
    } else {
      console.log(value);
      dispatch(updateGrille(value.id, value));
      // dispatch(createGrille(value.id,value));
      setShow(true);
      setTimeout(() => {
        history.push("quality-monitoring");
      }, 2000);
    }
  };
  const handleaddimpactCritere = () => {
    setValue({
      ...value,
      CriteriaGroup: [
        {
          Criteria: [
            {
              impact: true,
            },
          ],
        },
      ],
    });
  };
  const handelChangeValue = (e, datac, datag, datav) => {
    value.CriteriaGroup[datag].Criteria[datac].CriteriaValue[datav].name =
      e.target.value;
    setValue({
      ...value,
      CriteriaGroup: [...value.CriteriaGroup],
    });
  };
  const handelChangeBonus = (
    e,
    datac,
    datag,
    datav,
    datao,
    selectedcountbonus
  ) => {
    if (datao % 2 === 0 || datao === 0) {
      if (selectedcountbonus > 0 && datag === 0) {
        array2[datav] = {
          name: "",
          icon: "ICO.PNG",
          color: "none",
          CriteriaOptionValue: [],
        };
        setArray2({ ...array2 });
        value.CriteriaGroup[datag].Criteria[datac].CriteriaOption = [
          array2[datav],
        ];
      }
      if (datac > 0) {
        array4[datac] = {
          name: "",
          icon: "ICO.PNG",
          color: "none",
          CriteriaOptionValue: [],
        };
        setArray4({ ...array4 });
        value.CriteriaGroup[datag].Criteria[datac].CriteriaOption = [
          array4[datac],
        ];
      }
      if (datag > 0) {
        array3[datag] = {
          name: "",
          icon: "ICO.PNG",
          color: "none",
          CriteriaOptionValue: [],
        };
        setArray3({ ...array3 });
        value.CriteriaGroup[datag].Criteria[datac].CriteriaOption = [
          array3[datag],
        ];
      }
      if (selectedcountbonus === 0 && datag === 0 && datac === 0) {
        if (
          value.CriteriaGroup[datag].Criteria[datac].CriteriaOption.map(
            (e) => e.name === "Bonus"
          )[0] === (false || undefined) &&
          e === "Bonus"
        ) {
          array1.push({
            name: "",
            icon: "ICO.PNG",
            color: "none",
            CriteriaOptionValue: [],
          });
          setArray1([...array1]);

          value.CriteriaGroup[datag].Criteria[datac].CriteriaOption = array1;
        }
        if (
          value.CriteriaGroup[datag].Criteria[datac].CriteriaOption.map(
            (e) => e.name === "Malus"
          )[array1.length - 1] === false &&
          e === "Malus"
        ) {
          array1.push({
            name: "",
            icon: "ICO.PNG",
            color: "none",
            CriteriaOptionValue: [],
          });
          setArray1([...array1]);

          value.CriteriaGroup[datag].Criteria[datac].CriteriaOption = array1;
        }
      }

      value.CriteriaGroup[datag].Criteria[datac].CriteriaOption.map((i) =>
        i.name === "" ? (i.name = e) : null
      );

      setValue({
        ...value,
        CriteriaGroup: [...value.CriteriaGroup],
      });
    }
  };
  const handelChangeScore = (score, datac, datag, datav, datao, dataov) => {
    value.CriteriaGroup[datag].Criteria[datac].CriteriaOption[
      dataov - 1
    ].CriteriaOptionValue[datao].score = score;
    setValue({
      ...value,
      CriteriaGroup: [...value.CriteriaGroup],
    });
  };
  const handelEditName = (data, datav) => {
    setEditNameCritere(false);
    selectedcritere[data] = !editNameCritere;
    selectedgroupecritere[datav] = !editNameCritere;

    setSelectedcritere({ ...selectedcritere });
    setSelectedgroupecritere({ ...selectedgroupecritere });

    setEditNameCritere(!editNameCritere);
  };

  const handelChangeBonusComment = (e) => {
    if (e.Key === "Entre") {
      console.log(e.target.value);
    }
  };
  const handelChangeNameBonnus = (e, datac, datag, datav, datao, dataov, a) => {
    value.CriteriaGroup[datag].Criteria[datac].CriteriaOption[
      dataov - 1
    ].CriteriaOptionValue[datao].name = e.target.value;
    setValue({
      ...value,
      CriteriaGroup: [...value.CriteriaGroup],
    });
  };
  const handelopenGrille = (id) => {
    setOpenGroupeCritere(!openGroupeCritere);
    setSelectedGrille(id);
    selectedgrille[id] = !openGroupeCritere;
    setSelectedgrille({ ...selectedgrille });
  };
  const handelChangeValuedescription = (
    e,
    datac,
    datag,
    datav,
    colorCriteriaValue
  ) => {
    if (
      value.CriteriaGroup[datag].Criteria[datac].CriteriaValue[datav] &&
      colorCriteriaValue
    ) {
      value.CriteriaGroup[datag].Criteria[datac].CriteriaValue[
        datav
      ].description = e.target.value;
      value.CriteriaGroup[datag].Criteria[datac].CriteriaValue[datav].color =
        colorCriteriaValue;
      setValue({
        ...value,
        CriteriaGroup: [...value.CriteriaGroup],
      });
    }
    if (value.CriteriaGroup[datag].Criteria[datac].CriteriaValue[datav]) {
      value.CriteriaGroup[datag].Criteria[datac].CriteriaValue[
        datav
      ].description = e.target.value;
      setValue({
        ...value,
        CriteriaGroup: [...value.CriteriaGroup],
      });
    }
  };
  const handelChangeValueColor = (datac, datag, datav, colorCriteriaValue) => {
    if (value.CriteriaGroup[datag].Criteria[datac].CriteriaValue[datav]) {
      value.CriteriaGroup[datag].Criteria[datac].CriteriaValue[datav].color =
        colorCriteriaValue;
      setValue({
        ...value,
        CriteriaGroup: [...value.CriteriaGroup],
      });
    }
  };
  // ****************

  const popover = (
    <Tooltip id="tooltip-bottom-input" style={{ opacity: 1 }}>
      <Form.Control
        className={"form-control"}
        as="textarea"
        rows={3}
        placeholder={dup ? datagrille?.description : value?.description}
        defaultValue={dup ? datagrille?.description : ""}
        onKeyDown={handelchangeDescriptionNouvelleGrille}
      />
      <div className="buttons-of-textarea-comment">
        <span
          style={{ color: "#B7B7B7", cursor: "pointer" }}
          onClick={() => {
            setIsOpenComment(true);
          }}
        >
          Annuler
        </span>
        <span
          style={{ color: "#5800e2", cursor: "pointer" }}
          onClick={() => {
            setIsOpenComment(true);
          }}
        >
          Ajouter
        </span>
      </div>
    </Tooltip>
  );
  const popovergc = (id) => (
    <Tooltip id="tooltip-bottom-input" style={{ opacity: 1 }}>
      <Form.Control
        className={
          hasError("description") ? "form-control is-invalid" : "form-control"
        }
        as="textarea"
        rows={3}
        placeholder={
          dup ? datagrille?.CriteriaGroup[id]?.description : value?.description
        }
        defaultValue={dup ? datagrille?.CriteriaGroup[id]?.description : ""}
        onKeyDown={handelchangeDescriptionNouvelleCritere}
      />
      <div className="buttons-of-textarea-comment">
        <span
          style={{ color: "#B7B7B7", cursor: "pointer" }}
          onClick={() => {
            setIsOpenComment(true);
          }}
        >
          Annuler
        </span>
        <span
          style={{ color: "#5800e2", cursor: "pointer" }}
          onClick={() => {
            setIsOpenComment(true);
          }}
        >
          Ajouter
        </span>
      </div>
    </Tooltip>
  );
  const popoverAttributes = (
    <Tooltip
      id="tooltip-bottom-action"
      className="tooltip-attributes"
      style={{ opacity: 1 }}
    >
      <button
        style={{ border: "0px", backgroundColor: "transparent" }}
        onClick={() => {
          setIsCanal(!isCanal);
          handelchangeAttributNouvelleGrille(1);
        }}
      >
        {isCanal ? (
          <img alt="" src={CanalSelected} width={45} height={45} />
        ) : (
          <img alt="" src={Canal} width={45} height={45} />
        )}
      </button>
      <button
        value={"Norme"}
        style={{ border: "0px", backgroundColor: "transparent" }}
        onClick={() => {
          handelchangeAttributNouvelleGrille(2);
          setIsNorme(!isNorme);
        }}
      >
        {isNorme ? (
          <img alt="" src={NormeSelected} width={45} height={45} />
        ) : (
          <img alt="" src={Norme} width={45} height={45} />
        )}
      </button>
      <div
        onClick={() => {
          handelchangeAttributNouvelleGrille(3);
          setIsMotif(!isMotif);
        }}
      >
        {isMotif ? (
          <img alt="" src={MotifSelected} width={45} height={45} />
        ) : (
          <img alt="" src={Motif} width={45} height={45} />
        )}
      </div>
      <div
        onClick={() => {
          handelchangeAttributNouvelleGrille(4);
          setIsAutre(!isAutre);
        }}
      >
        {isAutre ? (
          <img alt="" src={AutreSelected} width={45} height={45} />
        ) : (
          <img alt="" src={Autre} width={45} height={45} />
        )}
      </div>
    </Tooltip>
  );
  return (
    <>
      <div id="nouvelle-eval-body">
        <div id="nouvelle-eval-bar">
          <div className="div-bar">
            <div
              onClick={() => history.goBack()}
              className="container-icon-arraw-left container-icon-arraw-left-add-grille"
            >
              <img src={iconLeftArrow} width="20" height="20" />
            </div>
            <Form.Control
              className={
                hasError("name") ? "form-control is-invalid" : "form-control"
              }
              //   placeholder="Nouvelle Grille"
              value={value.name}
              onChange={handelchangeNomNouvelleGrille}
              required
            />
            {isOpenComment ? (
              <div
                onClick={() => {
                  setIsOpenComment(false);
                }}
              >
                <img
                  className="img-chat-position-add-grille"
                  width={25}
                  src={iconChat}
                />
              </div>
            ) : (
              <OverlayTrigger
                trigger="click"
                rootClose
                placement="bottom-end"
                overlay={popover}
              >
                <img
                  className="img-chat-position-add-grille"
                  width={25}
                  src={iconChat}
                  onClick={() => {
                    setIsOpenComment(false);
                  }}
                />
              </OverlayTrigger>
            )}
          </div>
          <div className="div-bar">
            <OverlayTrigger
              trigger="click"
              rootClose
              placement="bottom-end"
              overlay={popoverAttributes}
            >
              <div
                onClick={() => setClickedAttributes(!clickedAttributes)}
                className={clsx("container-input-attributes", {
                  "container-input-attributes-selected": clickedAttributes,
                })}
              >
                <span style={{ fontSize: "13px", marginRight: "5px" }}>
                  Attributes
                </span>
                <img src={iconArrowDown} alt="Logo" height="6" />
              </div>
            </OverlayTrigger>
            <OverlayTrigger
              key="bottom"
              placement="bottom"
              overlay={
                <Tooltip data-color="#5800e2" id={`tooltip-bottom`}>
                  {!checked ? (
                    <span>Activer la grille</span>
                  ) : (
                    <span>Desactiver la grille</span>
                  )}
                </Tooltip>
              }
            >
              <div>
                <Switch
                  onChange={() => {
                    setChecked(!checked);
                    // handelchangeStatus(checked )
                  }}
                  checked={checked}
                  className={clsx(
                    { "activate-switch-btn": checked },
                    { "deactivate-switch-btn": !checked }
                  )}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  onColor="#5800e2"
                  height={20}
                  width={38}
                />
              </div>
            </OverlayTrigger>
          </div>
        </div>
        <div id="nouvelle-eval-under-bar" className="add-grille-body">
          <div
            className="container-add-groupe-critere"
            onClick={handeladdGroupeCriteres}
          >
            <img src={Plus} alt="Logo" height={22} />
            <span> Ajouter un groupe Critere</span>
          </div>

          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="characters">
              {(provided) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={{ height: "100%", padding: "10px" }}
                >
                  {value?.CriteriaGroup &&
                    value?.CriteriaGroup.map(({ id, name }, indexg) => {
                      return (
                        <Draggable
                          key={indexg}
                          draggableId={String(indexg)}
                          index={indexg}
                        >
                          {(provided) => (
                            <div className="row margin-0">
                              <div
                                className="container-groupe-critere"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <div
                                  className="row"
                                  style={{ height: "100%", margin: 0 }}
                                >
                                  <div className="container-drag-drop">
                                    <img src={PointsDragDrop} />
                                  </div>
                                  <div className="groupe-critere-name">
                                    {selectededitgc[indexg] ? (
                                      <div>
                                        {/* <span className="field__helper">
                                        Critere |
                                      </span> */}

                                        <Form.Control
                                          className={clsx(
                                            { field__input: true },
                                            {
                                              field__input:
                                                !selectededitgc[indexg],
                                            },
                                            {
                                              "form-control is-invalid":
                                                hasError("namegroupecritria"),
                                            },
                                            {
                                              "form-control ":
                                                !hasError("namegroupecritria"),
                                            }
                                          )}
                                          placeholder={
                                            dup
                                              ? datagrille?.CriteriaGroup[
                                                  indexg
                                                ]?.name
                                              : value?.CriteriaGroup[indexg]
                                                  ?.name
                                          }
                                          disabled={!selectededitgc[indexg]}
                                          defaultValue={
                                            dup
                                              ? datagrille?.CriteriaGroup[
                                                  indexg
                                                ]?.name
                                              : ""
                                          }
                                          type="text"
                                          onKeyDown={(e) =>
                                            handelchangeGroupCriterename(e, indexg)
                                          }
                                        />
                                      </div>
                                    ) : (
                                      <span
                                        className={clsx(
                                          {
                                            "form-control is-invalid":
                                              hasError("namegroupecritria"),
                                          },
                                          {
                                            "form-control":
                                              !hasError("namegroupecritria"),
                                          }
                                        )}
                                        style={{ border: "0.5px solid" }}
                                        onClick={() => {
                                          setGroupeCritereNameEdit(true);
                                          selectededitgc[indexg] =
                                            groupeCritereNameEdit;
                                          setSelectededitgc({
                                            ...selectededitgc,
                                          });
                                        }}
                                      >
                                        {dup
                                          ? datagrille?.CriteriaGroup[indexg]
                                              ?.name
                                          : value?.CriteriaGroup[indexg]?.name}
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div className="icons-groupe-critere">
                                  {selectededitgc[indexg] ? (
                                    <div
                                      className="container-icons-groupe-critere"
                                      onClick={() => {
                                        selectededitgc[indexg] = false;
                                        setSelectededitgc({
                                          ...selectededitgc,
                                        });
                                      }}
                                    >
                                      <img
                                        src={CheckCerclePrimary}
                                        height={15}
                                      />
                                    </div>
                                  ) : (
                                    <div
                                      className="container-icons-groupe-critere"
                                      onClick={() => {
                                        selectededitgc[indexg] = true;
                                        setSelectededitgc({
                                          ...selectededitgc,
                                        });
                                      }}
                                    >
                                      <img src={PenSelected} height={15} />
                                    </div>
                                  )}

                                  {isOpenComment ? (
                                    <div className="container-icons-groupe-critere">
                                      <img
                                        className="img-chat-position-groupe-critere"
                                        width={15}
                                        src={Chat}
                                        onClick={() => {
                                          setIsOpenComment(false);
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <div className="container-icons-groupe-critere">
                                      <OverlayTrigger
                                        trigger="click"
                                        rootClose
                                        placement="bottom-end"
                                        overlay={popovergc(indexg)}
                                      >
                                        <img
                                          className="img-chat-position-add-grille"
                                          width={15}
                                          src={Chat}
                                          onClick={() => {
                                            setIsOpenComment(false);
                                          }}
                                        />
                                      </OverlayTrigger>
                                    </div>
                                  )}

                                  <div
                                    className="container-icons-groupe-critere"
                                    onClick={() =>
                                      handelDeleteGroupeGrilles(indexg)
                                    }
                                  >
                                    <img width={15} src={Trash} />
                                  </div>

                                  <div
                                    className={clsx(
                                      {
                                        "container-icons-groupe-critere":
                                          selectedgrille[indexg],
                                      },
                                      {
                                        "container-icons-groupe-critere-selected":
                                          !selectedgrille[indexg],
                                      }
                                    )}
                                    onClick={() => {
                                      handelopenGrille(indexg);
                                    }}
                                  >
                                    {selectedgrille[indexg] ? (
                                      <img src={ArrowUpSelected} />
                                    ) : (
                                      <img src={ArrowDown} />
                                    )}
                                  </div>
                                </div>
                              </div>

                              {selectedgrille[indexg] ? (
                                <>
                                  <DragDropContext
                                    onDragEnd={handleOnDragEndCritere}
                                  >
                                    <Droppable droppableId="characterss">
                                      {(provided) => (
                                        <div
                                          className="characters"
                                          {...provided.droppableProps}
                                          ref={provided.innerRef}
                                          style={{
                                            width: "98%",
                                            padding: "3px",
                                          }}
                                        >
                                          {value.CriteriaGroup[indexg]
                                            .Criteria &&
                                            value.CriteriaGroup[
                                              indexg
                                            ].Criteria.map(
                                              ({ id, name, thumb }, index) => {
                                                return (
                                                  <Draggable
                                                    key={index}
                                                    draggableId={String(index)}
                                                    index={index}
                                                  >
                                                    {(provided) => (
                                                      <div
                                                        style={{
                                                          width: "100%",
                                                          padding: "10px",
                                                        }}
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                      >
                                                        <Critere
                                                          count={count}
                                                          id={index}
                                                          id1={indexg}
                                                          value={valeur}
                                                          data={value}
                                                          hasError={hasError}
                                                          selectedcritere={
                                                            selectedcritere
                                                          }
                                                          handelClosecommentCritere={
                                                            handelClosecommentCritere
                                                          }
                                                          isOpenComment1={
                                                            isOpenComment1
                                                          }
                                                          selectedgroupecritere={
                                                            selectedgroupecritere
                                                          }
                                                          editNameCritere={
                                                            editNameCritere
                                                          }
                                                          handelchangeDescriptionCritere={
                                                            handelchangeDescriptionCritere
                                                          }
                                                          handelChangeValuedescription={
                                                            handelChangeValuedescription
                                                          }
                                                          handelChangeValueColor={
                                                            handelChangeValueColor
                                                          }
                                                          handelChangeNameBonnus={
                                                            handelChangeNameBonnus
                                                          }
                                                          handelChangeBonusComment={
                                                            handelChangeBonusComment
                                                          }
                                                          handelEditName={
                                                            handelEditName
                                                          }
                                                          handelChangeScore={
                                                            handelChangeScore
                                                          }
                                                          handelChangeBonus={
                                                            handelChangeBonus
                                                          }
                                                          handelChangeValue={
                                                            handelChangeValue
                                                          }
                                                          handleaddimpactCritere={
                                                            handleaddimpactCritere
                                                          }
                                                          handelChangeNamecritere={
                                                            handelChangeNamecritere
                                                          }
                                                          handelDeleteCriters={
                                                            handelDeleteCriters
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  </Draggable>
                                                );
                                              }
                                            )}
                                          {provided.placeholder}
                                        </div>
                                      )}
                                    </Droppable>
                                  </DragDropContext>
                                  <div
                                    className="container-add-critere"
                                    onClick={() => {
                                      handeladdCriters(indexg);
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="22"
                                      height="22"
                                      viewBox="0 0 40 40"
                                    >
                                      <g
                                        id="Groupe_18605"
                                        data-name="Groupe 18605"
                                        transform="translate(-696 -140)"
                                      >
                                        <rect
                                          id="Rectangle_32"
                                          data-name="Rectangle 32"
                                          width="40"
                                          height="40"
                                          rx="20"
                                          transform="translate(696 140)"
                                          fill="#ccb2f6"
                                        />
                                        <path
                                          id="plus.2"
                                          d="M15.972,70.944H9.722v-6.25A.694.694,0,0,0,9.028,64H7.639a.694.694,0,0,0-.694.694v6.25H.694A.694.694,0,0,0,0,71.639v1.389a.694.694,0,0,0,.694.694h6.25v6.25a.694.694,0,0,0,.694.694H9.028a.694.694,0,0,0,.694-.694v-6.25h6.25a.694.694,0,0,0,.694-.694V71.639A.694.694,0,0,0,15.972,70.944Z"
                                          transform="translate(708 88)"
                                          fill="#fff"
                                        />
                                      </g>
                                    </svg>
                                    <span> Ajouter un Critere</span>
                                  </div>
                                </>
                              ) : null}
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <div
            style={{
              zIndex: "1",
              position: "fixed",
              right: "5%",
              bottom: "5%",
            }}
          >
            <Button
              variant="primary"
              className="buttons"
              style={{
                backgroundColor: "#5800e2",
                marginRight: "5px",
              }}
              onClick={handleSubmit}
            >
              Enregistrer
            </Button>

            <Button
              variant="primary"
              className="buttons"
              style={{
                backgroundColor: "white",
                borderColor: "gray",
                color: "gray",
              }}
              disabled
            >
              Annuler
            </Button>
          </div>
        </div>
        {message === "grille creadted and assinging to user successfully" && (
          <CToast
            autohide={false}
            visible={true}
            style={{
              zIndex: "1",
              position: "fixed",
              left: "5%",
              bottom: "5%",
              borderRadius: "10px",
            }}
          >
            <div
              className="d-flex"
              style={{
                width: "1000px",
                border: "1px solid #1CA91B",
                background: " white",
                borderRadius: "10px",
              }}
            >
              <img src={Rectangle} />
              <div>
                <CToastHeader
                  style={{ color: "#1CA91B", font: "bold", marginLeft: "25px" }}
                >
                  {" "}
                  Votre évaluation a était enregistrée avec succès
                </CToastHeader>
                <div className="d-flex">
                  <img
                    src={CheckSucessAlert}
                    style={{
                      height: 15,
                      alignItems: "center",
                      marginTop: "25px",
                      marginLeft: "5px",
                    }}
                  />
                  <CToastBody style={{ color: "#B7B7B7" }}>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.Lorem Ipsum is simply dummy text of the
                    printing and typesetting industry.
                  </CToastBody>
                  <img
                    src={Close}
                    style={{
                      height: 15,
                      alignItems: "center",
                      marginTop: "25px",
                      marginRight: "5px",
                    }}
                    onClick={() => setShow(true)}
                  />
                </div>
              </div>
            </div>
          </CToast>
        )}
      </div>
    </>
  );
};

export default EditGrille;
